
import * as vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dropdownOpen: false,
    };
  },
  computed: {
    selectedOption() {
      return this.options.find((option) => option.key === this.value);
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    selectOption(option) {
      if (this.selectedOption && this.selectedOption.key === option.key) {
        this.$emit("input", null);
      } else {
        this.$emit("input", option.key);
      }
      this.closeDropdown();
    },
    clearSelection() {
      this.$emit("input", null);
      this.closeDropdown();
    },
  },
};
